import React from "react";
import Css from "./Works.module.css";
import { NavLink, Outlet } from "react-router-dom";
const Works = () => {
  return (
    <div>
      <div  className={Css.parent}>
        <div className={Css.text}><h1><span>My</span> Works </h1></div>
        <nav className="works" id="works">
          <ul>
            <li>
              <NavLink to="/">All</NavLink>
            </li>
            <li>
              <NavLink to="css">Html & Css</NavLink>
            </li>
            <li>
              <NavLink to="native">JavaScript</NavLink>
            </li>
            <li>
              <NavLink to="react">React</NavLink>
            </li>
            <li>
              <NavLink to="fullstack">FullStack</NavLink>
            </li>
          </ul>
        </nav>
        <div className={Css.container}>
          <Outlet></Outlet>
        </div>
      </div>
    </div>
  );
};

export default Works;
